module.exports = __webpack_public_path__ + "static/media/avatar-S_J.98d8252b.png";